import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/sections/Hero";
import RevenueEngine from "../components/sections/RevenueEngine";
import AIBrain from "../components/sections/AIBrain";
import Industries from "../components/sections/Industries";
import CommandCenter from "../components/sections/CommandCenter";
import GlobeSection from "../components/sections/GlobeSection";
import Simulator from "../components/sections/Simulator";
import CompetitorAnalysis from "../components/sections/CompetitorAnalysis";
import CaseStudies from "../components/sections/CaseStudies";
import Contact from "../components/sections/Contact";
import Footer from "../components/Footer";

export default function Home({ openChat }) {
  return (
    <main className="relative" data-testid="home-page">
      <Nav onOpenChat={openChat} />
      <Hero onOpenChat={openChat} />
      <RevenueEngine />
      <AIBrain />
      <Industries />
      <CommandCenter />
      <GlobeSection />
      <Simulator />
      <CompetitorAnalysis />
      <CaseStudies />
      <Contact />
      <Footer />
    </main>
  );
}
